import { DotLoading, InfiniteScroll } from 'antd-mobile';
import { useEffect, useRef, useState } from 'react';
import './index.scss';
import { goWechat, processingParameters, setDocumentTitle } from '@/utils';
import wxPromisify from '../../libs/promiseWx/wxPromisify';
import api from '@/api';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import '@/view/CouponError/index.scss';
import { isEnv } from '@/utils';
import Loading from '@/components/Loading';
interface Coupon {
  couponType: number;
  templateName: string;
  couponInfo: string;
  effectiveEndTime: string;
  show: boolean;
  useInstructionList: any;
  shopIds: any;
  minConsumeValue: number;
  maxDiscountValue: number;
}
const COUPON_TYPE = 1;
const Coupon = () => {
  const btnBoxRef: any = useRef(null);
  const urlParam = useParams();

  const [coinList, setCoinList] = useState<Coupon[]>([]); // 券列表
  const [hasMoreCoin, setHasMoreCoin] = useState(false); // 是否加载
  const [markerCoin, setMarkerCoin] = useState(1); // 当前页码
  const [hasLoadCoinFirst, setHasLoadCoinFirst] = useState(false); // 是否第一页
  const pageSize = 10; //一页条数
  const navigate = useNavigate();
  const loadingRef = useRef<any>(); //loading
  useEffect(() => {
    const activity = sessionStorage.getItem('couponInfo');
    if (activity) {
      const newActivity: any = JSON.parse(activity);
      setDocumentTitle(newActivity.activityName);
      //设置分享
      const { mainTitle, subTitle, picture, shareLink } = newActivity;
      wxPromisify.setShareData({
        title: mainTitle, // 分享标题
        desc: subTitle, // 分享描述
        link: shareLink, //分享领券 登陆 页面
        imgUrl: picture,
      });
    }

    loadingRef.current.open();
    setTimeout(() => {
      loadMoreCoin();
      loadingRef.current.close();
    }, 1000);
  }, []);

  // 券列表
  async function handlerGetCoinRecordPage() {
    const send: any = {
      uid: urlParam?.uid,
      actId: urlParam?.id,
      time: new Date().getTime(),
    };
    // processingParameters(send, async (sign: string) => {
    //   send.sign = sign;
    // });
    send.sign = processingParameters(send);
    return await api.login
      .getUserCouponAndPageByActIdStaff({
        ...send,
        pageSize,
        pageNum: markerCoin,
      })
      .then((res: any) => {
        console.log(res, 'res');
        // 券已领完
        if (markerCoin === 1 && res.records.length === 0) {
          navigate('/customerError/603');
        }
        if (markerCoin === 1) {
          btnBoxRefInit();
        }
        setMarkerCoin(res.current + 1);
        setHasLoadCoinFirst(true);
        return {
          list: res.records,
          total: res?.total || 0,
        };
      });
  }

  // 分页
  async function loadMoreCoin() {
    if (!markerCoin && hasLoadCoinFirst) {
      setHasMoreCoin(false);
      btnBoxRefInit();
      return;
    }
    const res: any = await handlerGetCoinRecordPage();
    const newCoinPageList = res?.list;
    const total = res?.total;
    const showList = [
      ...(markerCoin === 1 ? [] : coinList),
      ...newCoinPageList,
    ];
    setCoinList(showList);
    setHasMoreCoin(showList.length < total);
  }

  const InfiniteScrollContent = ({ hasMore }: { hasMore?: boolean }) => {
    return (
      <>
        {hasMore ? (
          <>
            <span>Loading</span>
            <DotLoading />
          </>
        ) : (
          ''
        )}
      </>
    );
  };

  // 跳转小程序
  const btnBoxRefInit = () => {
    setTimeout(() => {
      if (!btnBoxRef.current) {
        return false;
      }
      goWechat(btnBoxRef);
    }, 500);
  };

  return (
    <>
      {coinList && coinList.length > 0 ? (
        <div className="coupon">
          <div className="coupon-info">
            <div className="tips">
              <img
                src={require('@/images/common/coupon_sucess.png')}
                className="tips-img"
              />
              <span className="tips-info">领取成功，已放入您的海底捞券包</span>
            </div>
            <div className="coupon-list">
              {coinList &&
                coinList.map((item, index) => (
                  <div key={index} className="coupon-item">
                    <img
                      src={require('@/images/common/coupon_icon.png')}
                      className="coupon-icon"
                    />
                    <div className="coupon-detail-top">
                      <div className="coupon-type">
                        <span>
                          {item.couponType === COUPON_TYPE ? '代金券' : ''}
                        </span>
                      </div>
                      <div className="coupon-name">
                        <span className="name">
                          立减
                          <span className="digatal">
                            {item.maxDiscountValue}
                          </span>
                          元
                        </span>
                        <div className="date">
                          <span>满{item.minConsumeValue}可用 | </span>
                          <span className="date-time">
                            {item.effectiveEndTime
                              ? dayjs(item.effectiveEndTime).format(
                                  'YYYY-MM-DD'
                                )
                              : ''}
                          </span>
                          <span>到期</span>
                        </div>
                      </div>
                    </div>
                    <div className="coupon-detail-bottom">
                      <div className="detail-title">
                        <span>仅限部分门店可用</span>
                        <span
                          onClick={() => {
                            item.show = !item.show;
                            const newData: Coupon[] = coinList;
                            setCoinList([...newData]);
                          }}
                        >
                          查看规则
                          {item.show ? (
                            <img
                              src={require('@/images/common/coupon_zk.png')}
                              alt="收起"
                              className="icon"
                            />
                          ) : (
                            <img
                              src={require('@/images/common/coupon_sq.png')}
                              alt="展开"
                              className="icon"
                            />
                          )}
                        </span>
                      </div>
                      {item.show ? (
                        <div className="content">
                          {item.useInstructionList &&
                            item.useInstructionList.map((info: string) => (
                              // eslint-disable-next-line react/jsx-key
                              <div>{info}</div>
                            ))}
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                ))}
            </div>
            {coinList && coinList.length > 0 ? (
              <InfiniteScroll
                loadMore={loadMoreCoin}
                hasMore={hasMoreCoin}
                threshold={40}
              >
                <InfiniteScrollContent hasMore={hasMoreCoin} />
              </InfiniteScroll>
            ) : (
              ''
            )}
          </div>
          {isEnv() === 'WxChat' ? (
            <div className="bottom">
              <div className="goWat">
                <span ref={btnBoxRef} className="coin_overdueBtnH5" />
                <span>跳转海底捞外送小程序查看券包</span>
              </div>
            </div>
          ) : null}
        </div>
      ) : (
        ''
      )}
      <Loading cRef={loadingRef} />
    </>
  );
};
export default Coupon;
